// Skeleton shimmer shown while a CMS page is loading.
// Uses the global `.skeleton` class (shimmer animation) from modern.css.

const line = (width, height = 14) => (
    <div className="skeleton" style={{ height, width, borderRadius: '6px' }} />
);

const CmsPageSkeleton = () => {
    const rowWidths = ['85%', '70%', '92%', '60%', '78%'];

    return (
        <div className="app-content">
            {/* Header */}
            <div style={{ marginBottom: 'var(--space-xl)' }}>
                {line('220px', 26)}
                <div style={{ marginTop: '10px' }}>{line('320px', 14)}</div>
            </div>

            {/* Content card */}
            <div className="bento-card">
                <div style={{ marginBottom: '20px' }}>{line('40%', 16)}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                    {rowWidths.map((w, i) => (
                        <div key={i}>{line(w, 14)}</div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CmsPageSkeleton;
